import React from "react";
import { NavLink } from "react-router-dom";

export default function BlogHomebox({ slug, lang, image, image_title, image_alt, date, title, tagline }) {
  

  return (
    <>

<div className="col-lg-4 col-md-6 mb-4">

    <div className="blog_card_pro">

        <div className="blog_card_img_wrap">

            <NavLink to={lang === "en" ? `/${slug}` : `/${lang}/${slug}`}>

                <img
                    src={image}
                    className="blog_card_img"
                    alt={image_alt}
                    title={image_title}
                />

            </NavLink>

            <span className="blog_card_badge">
                Latest Blog
            </span>

        </div>

        <div className="blog_card_content">

            <div className="blog_card_date">

                <i className="fa fa-calendar"></i>

                <span>{date}</span>

            </div>

            <NavLink
                to={lang === "en" ? `/${slug}` : `/${lang}/${slug}`}
                className="blog_title_link"
            >

                <h5 className="blog_card_title">
                    {title}
                </h5>

            </NavLink>

            <p className="blog_card_desc">
                {tagline}
            </p>

            <NavLink
                to={lang === "en" ? `/${slug}` : `/${lang}/${slug}`}
                className="blog_read_btn"
            >
                Read More
                <i className="fa fa-arrow-right"></i>
            </NavLink>

        </div>

    </div>

</div>

    </>
  );
}
